<template>
    <div class="progress-container">
        <div class="progress-bar-wrapper">
            <div class="new-progress-bar" role="progressbar" :aria-valuenow="valor" :aria-valuemin="0"
                :aria-valuemax="maxValue">
                <div class="new-progress-bar-fill" :style="fillStyle"></div>
                <span class="progress-value current-value" :style="currentValueStyle">{{ valor.toFixed(2) }}</span>
            </div>
            <div v-if="valor > 0" class="progress-indicator" :style="indicatorStyle"></div>
        </div>
        <div class="progress-values">
            <span class="progress-value min-value" :class="{ 'noShow': !showMinValue }">0</span>
            <span class="progress-value max-value" v-if="showMaxValue">{{ maxValue }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
            validator: value => ['SellerScore', 'RiskScore'].includes(value)
        },
        valor: {
            type: Number,
            required: true
        }
    },
    computed: {
        fillStyle() {
            return {
                width: this.getPercentage,
                backgroundColor: this.getBackground()
            };
        },
        maxValue() {
            return this.type === 'SellerScore' ? 1000 : 100;
        },
        getPercentage() {
            return `${this.calcPercentage(this.valor, this.maxValue)}%`;
        },
        getPercentageForHoriontalBar() {
            return `${this.calcPercentage(this.valor, this.maxValue) - 1.4}%`;
        },
        showMaxValue() {
            if (this.valor < 0) {
                return false;
            }
            return this.calcPercentage(this.valor, this.maxValue) <= 60;
        },
        showMinValue() {
            return this.valor >= (this.maxValue * 0.3);
        },
        currentValueStyle() {
            const color = this.verticalColor();
            if (this.valor < 0) {
                return { left: '50%', transform: 'translateX(-50%)', color };
            } else {
                return { left: this.getPercentage, transform: 'translateX(-50%)', color };
            }
        },
        indicatorStyle() {
            return {
                left: this.getPercentageForHoriontalBar,
                backgroundColor: this.verticalColor()
            };
        }
    },
    methods: {
        calcPercentage(value, max) {
            const percentage = Math.min(100, Math.max(0, (value / max) * 100));
            return percentage.toFixed(2);
        },
        verticalColor() {
            return this.getBackground();          
        },
        getBackground() {
            switch (this.type) {
                case 'RiskScore':
                    switch (true) {
                        case (this.valor > 80):
                            return '#FC183B';
                        case (this.valor > 60):
                            return '#FFA500';
                        case (this.valor > 45):
                            return '#FFD700';
                        case (this.valor > 25):
                            return '#8EBE23';
                        default:
                            return '#28A745';
                    }
                case 'SellerScore':
                default:
                    switch (true) {
                        case (this.valor > 800):
                            return '#28A745';
                        case (this.valor > 600):
                            return '#8EBE23';
                        case (this.valor > 450):
                            return '#FFD700';
                        case (this.valor > 250):
                            return '#FFA500';
                        default:
                            return '#FC183B';
                    }
            }
        }
    }
};
</script>

<style scoped>
.noShow {
    opacity: 0;
}

.progress-container {
    margin-top: 5px;
    border-radius: 5px;
}

.progress-bar-wrapper {
    width: 100%;
    min-width: 115px;
    height: 15px;
    border-radius: 5px;
    position: relative;
}

.new-progress-bar {
    width: 100%;
    height: 100%;
    background-color: #f0f0f0;
    position: relative;
    border-radius: 5px;
}

.new-progress-bar-fill {
    height: 100%;
    transition: width 0.3s ease, background-color 2s ease;
    border-radius: 5px;
    -webkit-mask: linear-gradient(#fff 0 0);
    mask: linear-gradient(#fff 0 0);
}

.current-value {
    position: relative;
    top: 8px;
    white-space: nowrap;
    font-size: 14px;
}

.progress-indicator {
    position: absolute;
    top: 8px;
    width: 2px;
    height: 20px;
    background-color: transparent;
    transition: left 0.3s ease;
}

.progress-values {
    display: flex;
    margin-top: 8px;
    width: 100%;
}

.progress-value {
    font-size: 14px;
}

.min-value {
    color: #B1B1B1;
    display: flex;
    justify-content: flex-start;
    width: 50%;
}

.max-value {
    color: #B1B1B1;
    display: flex;
    justify-content: flex-end;
    width: 50%;
}
</style>
